module.exports = "## Bottom Navigation\n\nThe [bottom navigation](https://www.google.com/design/spec/components/bottom-navigation.html#bottom-navigation-behavior) is a special kind of toolbar that’s used for navigation.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/BottomNavigation/README.md
 ** module id = 943
 ** module chunks = 0
 **/